import TruckService from "./TruckService";

class AccountService extends TruckService {

    loginAccount(account, afterResponse) {
        this.sendPostRequest('Login', account, afterResponse);
    }
}
export default AccountService; 